import React, { useContext } from 'react';
import noteContext from '../context/Notes/NoteContext';
import { Noteitem } from './Noteitem';
import Addnote from './Addnote';
import { useEffect, useRef } from 'react';

export const Notes = (props) => {
    let context = useContext(noteContext)
    const { notes, getallnotes } = context;

    const ref = useRef("")

    // props.showalert("Pankil","Success");

    useEffect(() => {
        getallnotes()
    }, [])

    return (
        <>
            <Addnote />
            <h1>Your Notes</h1>
            <div className="row d-flex">
                {notes.map((notes) => {
                    return (
                        <React.Fragment key={notes.title}>
                            <Noteitem note={notes} showalert={props.showalert}/>
                        </React.Fragment>
                    );
                })}
            </div>

        </>
    )
}


export default Notes